import { TwitterFollower } from '@/services/twitter';
import s from './styles.module.scss';
import cs from 'classnames';
import { APP_ENV } from '@/configs';
import { ROUTE_PATH } from '@/constants/route-path';
import { WalletContext } from '@/contexts/wallet-context';
import useAnalyticsEventTracker, { GameFiActions } from '@/utils/ga';
import { useContext } from 'react';
// import Avatar from '@/components/Avatar';
import { Flex } from '@chakra-ui/react';
import KeyPresaleIcon from '@/modules/AlphaPWA/Notification/svg/KeyPresaleIcon';
import { formatCurrency } from '@/utils';
import Avatar from '@/modules/AlphaPWA/Profiles/TradeKey/components/avatar';
import { TWITTER_SHARE_DM } from '@/constants/twitter';
import { getInvitedList, setInvitedList } from '@/utils/alpha.storage';
import { useRouter } from 'next/router';
import KeyIcon from '@/modules/AlphaPWA/Notification/svg/KeyIcon';

export default function FollowerItem({
  item,
  referralCode,
  hidePlaceHolder,
}: {
  item: TwitterFollower;
  referralCode?: string;
  hidePlaceHolder: boolean;
}) {
  const gaEventTracker = useAnalyticsEventTracker();
  const { addressL2 } = useContext(WalletContext);
  const router = useRouter();

  const getLink = () => {
    if (referralCode) {
      if (APP_ENV === 'production') {
        return `https://newbitcoincity.com?referral=${referralCode}`;
      }
      return `${window.location.origin}?referral=${referralCode}`;
    }
    return '';
  };

  const handleSetupInvitedList = () => {
    const invitedStorage = getInvitedList();

    if (!invitedStorage) {
      const invitedFollower = new Map();
      invitedFollower.set(item.twitterUsername, 1);
      setInvitedList(invitedFollower);
    } else {
      //check if existed in local
      const checkExistInInvitedList = !!invitedStorage?.get(
        item.twitterUsername
      );
      const inviteCount = invitedStorage?.get(item.twitterUsername);
      invitedStorage?.set(
        item.twitterUsername,
        checkExistInInvitedList && inviteCount ? inviteCount + 1 : 1
      );

      setInvitedList(invitedStorage);
    }
  };

  const routeToThreeThreeTrade = () => {
    if (!item.tokenAddress || item.isPreSale) return;

    router.push(
      `${ROUTE_PATH.ALPHA_MOBILE_PROFILE}/${item.walletAddress}?showRequest=true`
    );
  };

  return (
    <div className={s.followerItem}>
      <div className={cs(s.followerItem__item, s.followerPlayer)}>
        <div className={s.avatar}>
          {item && item.profileUrl && (
            // <Avatar width={36} height={36} imgSrcs={item.profileUrl} />
            <Avatar url={item.profileUrl} width={36} />
          )}
        </div>
        <div className={cs(s.followerItem__info)}>
          <Flex alignItems={'center'} gap="7px">
            <div className={cs(s.followerItem__item__label)}>{item.name}</div>
            {!!item.tokenAddress && (
              <div className={s.presale}>
                {item.isPreSale ? <KeyPresaleIcon /> : <KeyIcon />}
              </div>
            )}
          </Flex>

          <div className={cs(s.invitedItem__item__value)}>
            @{item.twitterUsername}
          </div>
        </div>
      </div>

      <div className={cs(s.followerItem__item, s.inviteControl)}>
        <>
          {!hidePlaceHolder && (
            <>
              {!!item.tokenAddress && (
                <div className={s.followerItem__volume}>
                  <div>{formatCurrency(item.buyPrice, 0, 6, 'BTC')} BTC</div>
                  <div>{item.isPreSale && 'Placeholder'} Key value</div>
                  {/* <div>{formatCurrency(item.vol, 0, 6, 'BTC')} BTC</div>
                    <div>Volume</div> */}
                </div>
              )}
            </>
          )}
        </>
        {!item.tokenAddress || item.isPreSale ? (
          <button
            className={s.shareTwitter}
            onClick={e => {
              e.preventDefault();
              handleSetupInvitedList();
              const shareUrl = getLink();
              const content = `${TWITTER_SHARE_DM}${shareUrl}`;

              gaEventTracker(
                GameFiActions.TweetReferralCodeToExactUser,
                addressL2
              );
              window.open(
                `https://twitter.com/messages/compose?recipient_id=${
                  item.twitterId
                }&text=${encodeURIComponent(content)}`
              );
            }}
          >
            <span>Invite</span>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.224 4.0554C13.813 4.23247 13.3808 4.35577 12.9383 4.42225C13.1452 4.38675 13.4496 4.01398 13.5708 3.8631C13.7549 3.63551 13.8952 3.3757 13.9846 3.09686C13.9846 3.07615 14.0053 3.04657 13.9846 3.03178C13.9742 3.02608 13.9625 3.02309 13.9506 3.02309C13.9388 3.02309 13.9271 3.02608 13.9166 3.03178C13.4361 3.29225 12.9246 3.49104 12.3944 3.62347C12.3759 3.62912 12.3562 3.62963 12.3375 3.62493C12.3187 3.62024 12.3016 3.61053 12.288 3.59684C12.2467 3.54765 12.2023 3.5012 12.155 3.45779C11.9387 3.26385 11.6933 3.10512 11.4278 2.9874C11.0694 2.84024 10.6823 2.77651 10.2958 2.80102C9.92063 2.82473 9.5544 2.92543 9.21983 3.09686C8.89036 3.2776 8.6008 3.52314 8.36855 3.81873C8.12425 4.12296 7.94787 4.47603 7.85128 4.85419C7.77163 5.21389 7.7626 5.58566 7.82468 5.94881C7.82468 6.01094 7.82468 6.01982 7.77147 6.01094C5.66397 5.7003 3.93481 4.95181 2.52192 3.34537C2.45985 3.27437 2.42734 3.27437 2.37709 3.34537C1.76227 4.28025 2.06081 5.75947 2.82933 6.49021C2.93278 6.58784 3.03919 6.68251 3.15151 6.77127C2.79915 6.74623 2.4554 6.65066 2.14062 6.49021C2.0815 6.45175 2.04899 6.47246 2.04603 6.54346C2.03765 6.6419 2.03765 6.74087 2.04603 6.83931C2.10771 7.31106 2.29346 7.75796 2.58429 8.1343C2.87512 8.51063 3.2606 8.80291 3.7013 8.98123C3.80873 9.02729 3.92067 9.06199 4.03531 9.08478C3.70911 9.14906 3.37455 9.15905 3.0451 9.11436C2.97416 9.09957 2.94756 9.13803 2.97416 9.20607C3.40867 10.3895 4.35158 10.7504 5.04324 10.9516C5.13783 10.9664 5.23242 10.9664 5.33883 10.99C5.33883 10.99 5.33883 10.99 5.32109 11.0078C5.11714 11.3805 4.29246 11.632 3.91412 11.7622C3.22354 12.0105 2.48725 12.1053 1.75636 12.0403C1.64108 12.0225 1.61448 12.0255 1.58492 12.0403C1.55537 12.0551 1.58492 12.0876 1.61744 12.1172C1.76523 12.2148 1.91302 12.3006 2.06672 12.3835C2.5243 12.6333 3.00805 12.8317 3.50917 12.9751C6.10439 13.6911 9.02474 13.1645 10.9726 11.2267C12.5038 9.70605 13.0417 7.60851 13.0417 5.508C13.0417 5.42813 13.1393 5.38079 13.1954 5.33937C13.5828 5.03728 13.9243 4.68052 14.2093 4.28025C14.2586 4.22058 14.2839 4.14461 14.2802 4.06724C14.2802 4.02286 14.2802 4.03173 14.224 4.0554Z"
                fill="#4C9EEB"
              />
            </svg>
          </button>
        ) : (
          <button
            className={cs(s.shareTwitter, s.trade)}
            onClick={routeToThreeThreeTrade}
          >
            (3.3)
          </button>
        )}
      </div>
    </div>
  );
}
